import React from 'react';
import GainsMonitorDashboard, { type GainsMonitorView } from './GainsMonitorDashboard';
import KaizenForm from './KaizenForm';

interface GainsMonitorPageProps {
  organizationId: string;
  projectId?: string;
  view: GainsMonitorView;
  refreshKey: number;
  showKaizenForm: boolean;
  formProjectId: string | null;
  onKaizenSuccess: () => void;
  onKaizenCancel: () => void;
  onSelectedKaizenChange: (kaizen: { id: string; projectId: string | null; title: string } | null) => void;
  measurementRequest: number;
}

export const GainsMonitorPage: React.FC<GainsMonitorPageProps> = ({
  organizationId,
  projectId,
  view,
  refreshKey,
  showKaizenForm,
  formProjectId,
  onKaizenSuccess,
  onKaizenCancel,
  onSelectedKaizenChange,
  measurementRequest,
}) => {
  return (
    <div className="relative flex h-full w-full flex-col">
      <div data-gains-dashboard className="min-h-0 flex-1 overflow-auto">
        <GainsMonitorDashboard
          key={refreshKey}
          organizationId={organizationId}
          projectId={projectId}
          view={view}
          onSelectedKaizenChange={onSelectedKaizenChange}
          measurementRequest={measurementRequest}
        />
      </div>

      {showKaizenForm && formProjectId && (
        <KaizenForm
          projectId={formProjectId}
          organizationId={organizationId}
          onSuccess={onKaizenSuccess}
          onCancel={onKaizenCancel}
        />
      )}

    </div>
  );
};

export default GainsMonitorPage;
